<template>
  <div
    v-if="formsLoaded"
    id="app"
  >
    <Nav />
    <router-view />
  </div>
</template>

<script>
import cacheLoader from '@/mixins/loaders/cache-loader';

export default {
  components: {
    Nav: () => import('@/components/layout/Nav'),
  },

  mixins: [cacheLoader],
};
</script>


<style>
@import url('https://fonts.googleapis.com/css?family=Raleway|Roboto+Mono:100,400,500,700');
@import '~bootstrap/dist/css/bootstrap.css';
@import '~bootstrap-vue/dist/bootstrap-vue.css';
@import '~v-calendar/lib/v-calendar.min.css';

body {
  font-family: 'Roboto Mono', cursive;
  padding: 1em 2em;
}
</style>
